module.exports = __webpack_public_path__ + "static/img/10introduce.8aa97fca.jpg";